import SellerboxBoxLogo from '@/assets/icons/sellerbox-box-logo.svg?react';
import { useAppSelector } from '@/redux/store';
import useWebview from '@/hooks/V3/useWebview';
import { useSearchParams } from 'react-router-dom';

import {
  buildStatisticsPreviewMembershipUrl,
  getStatisticsPreviewMembershipCtaCopy,
} from './statistics-preview-membership-cta';

const StatisticsPreviewMembershipCTA = () => {
  const { CplatToken } = useAppSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const { postMessage } = useWebview();
  const copy = getStatisticsPreviewMembershipCtaCopy();
  const membershipUrl = buildStatisticsPreviewMembershipUrl(
    CplatToken || searchParams.get('cplatToken'),
  );

  const handleClick = () => {
    if (window.ReactNativeWebView) {
      postMessage({
        action: 'openExternal',
        data: membershipUrl,
      });
      return;
    }

    window.open(membershipUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="pointer-events-none absolute bottom-[23px] left-[20px] right-[20px] z-20">
      <button
        type="button"
        aria-label="멤버십 혜택 페이지로 이동"
        className="pointer-events-auto flex min-h-[68px] w-full items-center gap-[8px] rounded-[10px] bg-gr-50 p-[16px] text-left"
        data-membership-preview-interactive="true"
        onClick={handleClick}
      >
        <SellerboxBoxLogo aria-hidden className="h-[36px] w-[36px] flex-none" />
        <span className="flex min-w-0 flex-1 flex-col gap-[2px]">
          <span className="truncate text-gr-800 Body3S15">{copy.title}</span>
          <span className="truncate text-gr-600 Caption1M12">{copy.description}</span>
        </span>
      </button>
    </div>
  );
};

export default StatisticsPreviewMembershipCTA;
